import React, { createRef, useCallback, useEffect } from 'react';
import GettingStartedPlanForm from './GettingStartedPlanForm';
import GettingStartedSteps from './GettingStartedSteps';
import GettingStartedPackage from './GettingStartedPackage/GettingStartedPackage';
import GettingStartedDelivery from './GettingStartedDelivery/GettingStartedDelivery';
import GettingStartedAddress from './GettingStartedAddress';
import { useDispatch, useSelector } from '../store';
import { gettingStartedPlanSelector } from '../store/selectors';
import { prepareQuestionnairePlanData } from '../utils/data';

const GettingStartedPlan = ({ form: formProps, ...initialProps }) => {
  const dispatch = useDispatch();
  const {
    prices,
    roomsPackages,
    roomsDelivery,
    values,
    packagesOptions,
    plansOptions,
    form: formState,
  } = useSelector(gettingStartedPlanSelector);
  const form = createRef();

  useEffect(() => {
    dispatch({
      type: 'gettingStartedPlan/update',
      payload: prepareQuestionnairePlanData(initialProps),
    });
  }, []);

  const handlePackageChange = useCallback(
    (room, newPackage) => {
      const newPackages = {
        ...values.packages,
        [room.value]: {
          ...(values.packages[room.value] || {}),
          plan: newPackage.id,
        },
      };
      dispatch({ type: 'gettingStartedPlan/update', payload: { packages: newPackages } });
    },
    [values.packages],
  );

  const handleDeliveryChange = useCallback(
    (room, newDelivery) => {
      const newPackages = {
        ...values.packages,
        [room.value]: {
          ...(values.packages[room.value] || {}),
          term: newDelivery.id,
        },
      };
      dispatch({ type: 'gettingStartedPlan/update', payload: { packages: newPackages } });
    },
    [values.packages],
  );

  const handlePackageRemove = useCallback(
    room => {
      const newRooms = values.rooms.reduce((acct, r) => {
        if (r.type !== room.name) return { ...acct, [r.type]: r.quantity };
        return { ...acct, [r.type]: r.quantity - 1 };
      }, {});
      const keyToDrop = Object.keys(values.packages)
        .reverse()
        .find(k => k.includes(`${room.name}_`));
      const { [keyToDrop]: _, ...newPackages } = values.packages;
      dispatch({
        type: 'gettingStartedPlan/update',
        payload: { rooms: newRooms, packages: newPackages },
      });
    },
    [values.packages],
  );

  const handleAddressChange = useCallback(address => {
    dispatch({ type: 'gettingStartedPlan/update', payload: { address } });
  }, []);

  const handleNext = useCallback(
    () => {
      if (form && form.current) {
        form.current.submit();
      }
    },
    [form],
  );

  const handlePrevious = useCallback(() => {
    window.location = '/getting_started/step1#question-4';
  }, []);

  return (
    <GettingStartedPlanForm ref={form} {...formProps} values={{ questionnaire: values }}>
      <GettingStartedSteps
        invalid={[formState.packageInvalid, formState.deliveryInvalid, formState.addressInvalid]}
        onNext={handleNext}
        onPrevious={handlePrevious}
      >
        <GettingStartedPackage
          value={values.packages}
          rooms={roomsPackages}
          prices={prices}
          packages={plansOptions}
          onChange={handlePackageChange}
          onRemove={handlePackageRemove}
        />
        <GettingStartedDelivery
          value={values.packages}
          rooms={roomsDelivery}
          prices={prices}
          delivery={packagesOptions}
          onChange={handleDeliveryChange}
        />
        <GettingStartedAddress value={values.address} onChange={handleAddressChange} />
      </GettingStartedSteps>
    </GettingStartedPlanForm>
  );
};

export default GettingStartedPlan;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedPlan.js